import { render, staticRenderFns } from "./nodeparameter.vue?vue&type=template&id=55ad48d2&scoped=true"
import script from "./nodeparameter.vue?vue&type=script&lang=js"
export * from "./nodeparameter.vue?vue&type=script&lang=js"
import style0 from "./nodeparameter.vue?vue&type=style&index=0&id=55ad48d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ad48d2",
  null
  
)

export default component.exports